import { render, staticRenderFns } from "./contact-list-item.vue?vue&type=template&id=1913f657&scoped=true&"
import script from "./contact-list-item.vue?vue&type=script&lang=js&"
export * from "./contact-list-item.vue?vue&type=script&lang=js&"
import style0 from "./contact-list-item.vue?vue&type=style&index=0&id=1913f657&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913f657",
  null
  
)

/* custom blocks */
import block0 from "./contact-list-item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports